export default "__VITE_ASSET__C3bYrrtD__"